<div class="space-y-6">
  <!-- Create/Update Sub-feature Option Form -->
  <div
    class="card-bg rounded-2xl p-6 border border-slate-200 dark:border-white/5 backdrop-blur-xl animate-in slide-in-from-top-4 duration-500 relative z-50 !overflow-visible">
    <h2 class="text-xl font-bold bg-gradient-to-r from-violet-400 to-indigo-500 bg-clip-text text-transparent mb-6">
      {{ isEditMode() ? 'Updating Variant' : 'New Feature Option/Variant' }}
    </h2>

    <div class="grid grid-cols-12 gap-4 md:gap-5 items-end">
      <div class="col-span-12 sm:col-span-6 lg:col-span-3">
        <app-dropdown [title]="'Parent Feature'" [options]="featureDropdownOptions()"
          [selectedValue]="String(currentOption.feature_id)" selectionMode="single" placeholder="Select feature"
          [fullWidth]="true" size="lg" variant="themeBase" (selectionChange)="onFeatureFilter($event)" />
      </div>
      <div class="col-span-12 sm:col-span-6 lg:col-span-2">
        <app-input label="Option Label" [(ngModel)]="currentOption.name" placeholder="E.g., Cold Call" [fullWidth]="true"
          variant="themeBase" size="lg" />
      </div>
      <div class="col-span-12 sm:col-span-6 lg:col-span-2">
        <app-input label="Keyname" [(ngModel)]="currentOption.keyname" placeholder="cold_call" [fullWidth]="true"
          variant="themeBase" size="lg" />
      </div>
      <div class="col-span-12 sm:col-span-6 lg:col-span-2">
        <app-input label="Description" [(ngModel)]="currentOption.description" placeholder="Notes for this variant"
          [fullWidth]="true" variant="themeBase" size="lg" />
      </div>
      <div class="col-span-12 sm:col-span-12 lg:col-span-3 flex gap-2">
        <div class="flex-1">
          <app-button [variant]="isEditMode() ? 'secondary' : 'primary'" (buttonClick)="saveOption()"
            [disabled]="!currentOption.name || !currentOption.keyname || !currentOption.feature_id"
            className="w-full !h-12 whitespace-nowrap">
            {{ isEditMode() ? 'Sync Changes' : 'Add' }}
          </app-button>
        </div>
        @if (isEditMode()) {
        <app-button variant="secondary" (buttonClick)="resetForm()"
          className="bg-slate-200 dark:bg-slate-700 !h-12 w-12 p-0 flex items-center justify-center shrink-0">
          <app-icon name="x" [size]="18"></app-icon>
        </app-button>
        }
      </div>
    </div>
  </div>

  <!-- Logic to view options for a specific feature -->
  @if (!selectedFeatureId()) {
  <div
    class="p-12 text-center card-bg rounded-2xl border border-dashed border-slate-300 dark:border-slate-700 flex flex-col items-center gap-4">
    <div class="w-12 h-12 rounded-full bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-xl">💡</div>
    <p class="text-slate-500">Please select a Parent Feature to view and manage its configuration options.</p>
  </div>
  } @else {
  <div class="card-bg rounded-2xl p-6 border border-slate-200 dark:border-white/5 animate-in fade-in duration-700">
    <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
      <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200">
        Configured Options for <span class="text-indigo-600 dark:text-indigo-400 font-bold">"{{ getSelectedFeatureName()
          }}"</span>
      </h3>
      <span
        class="px-3 py-1 bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400 rounded-full text-xs font-medium">
        {{ options().length }} variants found
      </span>
    </div>

    <app-paginated-table [headers]="headers" [tableData]="options()" [isCheckboxShow]="false"
      [tableActionOptions]="{ showToggleButton: true, toggleOptions: actionOptions }"
      (actionSelected)="handleAction($event)" [tableWrapperClass]="'!h-auto !overflow-x-auto !bg-transparent !backdrop-blur-none !shadow-none !border-none'"/>
  </div>
  }

  <!-- Global Alert Feedback -->
  @if (successMessage()) {
  <app-alert [message]="successMessage()" type="success" [duration]="3000" (close)="successMessage.set('')" />
  }
</div>